import { btnDelay, usePlaySound } from "common/utils";
import i18n from "features/parent/i18n";
import { ParentPieceReport } from "features/parent/types";
import { ParentPieceReportRow } from "./ParentPieceReportRow";

interface PieceReportsSectionProps {
  reports: ParentPieceReport[];
  onSelectReport: (report: ParentPieceReport) => void;
  onShowMore: () => void;
}

export const PieceReportsSection = ({
  reports,
  onSelectReport,
  onShowMore,
}: PieceReportsSectionProps) => {
  const play = usePlaySound();

  return (
    <div className="bg-white rounded-[16px] p-6">
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">flag</span>
          {i18n.t("MSG_PARENT_PAGE_PLAYER_REPORTS")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">({reports.length})</span>
        </div>
        {reports.length > 3 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-white border border-gray2-60 rounded-full text-[21px] text-textcolor-black cursor-pointer hover:bg-gray2-20 transition-all"
            onClick={() => {
              play();
              btnDelay(onShowMore);
            }}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
          </button>
        )}
      </div>

      {reports.length > 0 ? (
        <div className="flex-col-el gap-3">
          {reports.slice(0, 3).map((report) => (
            <ParentPieceReportRow
              key={report.id}
              report={report}
              onClick={() => {
                play();
                btnDelay(() => onSelectReport(report));
              }}
            />
          ))}
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">flag</span>
          <span className="text-[21px]">{i18n.t("MSG_PARENT_PAGE_PLAYER_REPORTS_EMPTY")}</span>
        </div>
      )}
    </div>
  );
};
